import React from "react";
import "./Loader.scss";

const Loader = ({
  size = "md", // sm | md | lg
  overlay = false, // true = fullscreen / section overlay
  text = "", // optional loading text
}) => {
  return (
    <div className={`loader-wrapper ${overlay ? "overlay" : ""}`}>
      <div className={`loader-spinner ${size}`} />
      {text && <div className="loader-text">{text}</div>}
    </div>
  );
};

export default Loader;
